import React from "react";
import { getKhattabatResultsStore } from "../../../../../stores/khattabat-stores/results-store";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Conversation from "./conversation";
import Header from "./header";

const Conversations = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const usersData =
    getKhattabatResultsStore().getFormatedMatchesConversationsComputed.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="space-between"
      alignItems="center"
      withShadow={true}
      width={1450}
      height={0}
      color={colors.all.white}
      style={{
        borderRadius: 30 * unitX,
        overflow: "hidden"
      }}
      onClick={() => { }}
    >
      {usersData.map((usersData) => {
        return (
          <React.Fragment>
            <Header
              matchID={usersData.matchID}
              matchUserName={usersData.matchUserName}
              residence={usersData.matchResidence}
              nationality={usersData.matchNationality}
              age={usersData.matchAge}
              height={usersData.matchHeight}
              weight={usersData.matchWeight}
              lastLogin={usersData.matchLastLogin}
              marriageType={usersData.marriageType}
              isOpenedConversation={usersData.isOpenedConversation}
              matchUnreadMessages={usersData.matchUnreadMessages}
              alkhattabaUUID={usersData.alkhattabaUUID}
              matchUUID={usersData.matchUUID}
            />
            <Conversation
              clientID={usersData.clientID}
              clientUUID={usersData.clientUUID}
              alkhattabaUUID={usersData.alkhattabaUUID}
              matchID={usersData.matchID}
              matchUUID={usersData.matchUUID}
              messages={usersData.messages}
              oneOTwoConversationId={""}
              matchStatus={usersData.matchStatus}
              matchConversationID={usersData.matchConversationID}
              isOpenedConversation={usersData.isOpenedConversation}
              matchUnreadMessages={usersData.matchUnreadMessages}
              matchConvesationIsDisabled={usersData.matchConvesationIsDisabled}
              conversationID={usersData.matchConversationID}
              isHighlighted={usersData.matchConversationIsHighlighted}
              matchComments={usersData.matchComments}
              matchHasDeletedTheConversation={
                usersData.matchHasDeletedTheConversation
              }
            />
          </React.Fragment>
        );
      })}
    </ET3Div>
  );
});

export default Conversations;
